import { render, staticRenderFns } from "./CDialogFeedback.vue?vue&type=template&id=e97f320e&scoped=true"
import script from "./CDialogFeedback.vue?vue&type=script&setup=true&lang=js"
export * from "./CDialogFeedback.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CDialogFeedback.vue?vue&type=style&index=0&id=e97f320e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e97f320e",
  null
  
)

export default component.exports